import React from "react";
import TextField from "@material-ui/core/TextField";
// import {
//   FromContentType,
//   AutoCompleteSchemaProps
// } from "./interface";
import HookFormSelect from "./HookFormSelect";
import HookFormUpload from "./HookFormUpload";
import HookTimePicker from "./HookTimePicker";
import HookFormDownload from "./HookFormDownload";
export default function HookFormContent(props) {
    const { formContext, schema } = props;
    const { value, type, name, label, validate, ...rest } = schema;
    if (type === "text")
        return (<>
      {value}
    </>);
    let content;
    let selectProps = {};
    const { register, errors, control } = formContext;
    const error = errors[name];
    switch (type) {
        case "file":
            content = <HookFormUpload name={name} validate={validate} formContext={formContext} value={value} label={label}/>;
            break;
        // eslint-disable-next-line
        case "password":
        case "disabled":
        case "input":
            const { variant, InputProps } = rest;
            content = <TextField key={value} inputRef={register(validate || {})} name={name} required={validate && !!validate.required} fullWidth error={!!error} variant={variant} InputProps={InputProps} helperText={error ? error.message : null} label={label} type={type} defaultValue={value}/>;
            break;
        case "multiSelect":
            selectProps.multiple = true;
        // eslint-disable-next-line
        case "select":
            const { selectSchema, onChange } = rest;
            content = <HookFormSelect control={control} name={name} error={!!error} helperText={error ? error.message : null} selectSchema={selectSchema} defaultValue={value} selectProps={selectProps} label={label} rules={validate} onChange={onChange}/>;
            break;
        case "time":
            content = <HookTimePicker name={name} value={value} label={label} control={control} error={error} validate={validate} {...rest}/>;
            break;
        case "download":
            content = <HookFormDownload name={name} value={value} label={label} control={control}/>;
            break;
        default:
            content = <>
        {value}
      </>;
            break;
    }
    return (<>
      {content}
    </>);
}
